import React, { Fragment } from "react"
import { withRouter } from "react-router-dom"
import Carousel from "react-slick"
import styled from "styled-components"
import ReactPlayer from "react-player"

import leftimage from '../../images/arrowleft.svg'
import rightimage from '../../images/arrowright.svg'
import config from "../../Config"
import "./carousel.css"

const Container = styled.div`
  height: ${(props) => props.maxHeight};
  overflow: hidden;
  position: relative;
`

const ShareBox = styled.div`
  width: 59px;
  height: 25px;
  border-radius: 4px;
  position: absolute;
  z-index: 2;
  right: 12px;
  margin-top: 12px;
  position: absolute;
`

const RightNavButton = (props) => {
  return (
    <button onClick={props.onClick} type='button' className={props.className}>
      <img
        src={rightimage}
        onClick={props.onClick}
        className='slick-next'
        alt='slick-next'
        style={{width:"20px"}}

      />
    </button>
  )
}

const LeftNavButton = (props) => (
  <button onClick={props.onClick} type='button' className={props.className}>
    <img
      src={leftimage}
      onClick={props.onClick}
      className='slick-next'
      alt='slick-next'
      style={{width:"20px"}}
    />
  </button>
)

class CarouselView extends React.Component {
  constructor(props) {
    super(props)
    this.play = this.play.bind(this)
    this.pause = this.pause.bind(this)
    this.onSelect = this.onSelect.bind(this)
  }

  play() {
    // console.log("----- play ------")
    // this.slider.slickPlay();
  }

  pause() {
    // console.log("----- pause ------")
    // this.slider.slickPause();
  }

  onSelect(actionUrl) {
    if (actionUrl) {
      // window.location.href = actionUrl
      window.open(actionUrl, "_blank").focus()
    }
  }

  render() {
    // console.log("CarouselView state -->>",this.state);
    console.log("carousel props", this.props)
    const { data, onSelect, maxHeight, share, history } = this.props
    const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 2800,
      autoplaySpeed: 2000,
      autoplay: true,
      arrows: true,
      pauseOnHover: true,
      pauseOnDotsHover: true,
      pauseOnFocus: true,
      focusOnSelect: true,
      nextArrow: <RightNavButton />,
      prevArrow: <LeftNavButton />,
    }
    return (
      <Container maxHeight={maxHeight}>
        {share && (
          <ShareBox>
            <img
              src={`${config.MRBIDNWIN_S3_IMAGE_URL}/share.svg`}
              alt='share'
            />
          </ShareBox>
        )}
        <Carousel ref={(slider) => (this.slider = slider)} {...settings}>
          {data.map((el, index) => {
            return (
              <Fragment key={index}>
                {el.type === "IMAGE" && (
                  <img
                    src={el.resourceUrl}
                    alt={`${++index}-slide`}
                    className='slick-image fit_to_screen'
                    height={maxHeight}
                  />
                )}
                {el.type === "EXTERNAL" && (
                  <img
                    src={el.resourceUrl}
                    alt={`${++index}-slide`}
                    className='slick-image fit_to_screen'
                    height={maxHeight}
                    onClick={() => this.onSelect(el.actionUrl)}
                    style={{ cursor: "pointer" }}
                  />
                )}
                {el.type === "BIDS" && (
                  <img
                    src={el.resourceUrl}
                    alt={`${++index}-slide`}
                    className='slick-image fit_to_screen'
                    height={maxHeight}
                    onClick={() =>
                      history.push(
                        `/play/product-details/${el.offerTitle}/${el.offerId}`
                      )
                    }
                    style={{ cursor: "pointer" }}
                  />
                )}
                {el.type === "VIDEO" && (
                  <ReactPlayer
                    id='react-player'
                    url={el.resourceUrl}
                    width='100%'
                    height='100%'
                    onPause={this.play}
                    controls={true}
                  />
                )}
              </Fragment>
            )
          })}
        </Carousel>
      </Container>
    )
  }
}

export default withRouter(CarouselView)



// WEBPACK FOOTER //
// ./src/components/carousel/index.js